"use client"

import { useLocale, useTranslations } from "next-intl"
import Link from "next/link"


type Props = {
  name: string
  className: string
  description?: string
  subUrl?: string
}

export const Banner = ({ name, className, description, subUrl }: Props) => {
  const  t  = useTranslations()
  const locale=useLocale()
  
  return (
    <div
      className={` ${className} flex h-80 flex-col items-center justify-center gap-2 bg-cover bg-center bg-no-repeat text-white`}
    >
      <div className='flex justify-center gap-2'>
        <Link href='/'>{t('homePage.home')}</Link>
        <span>/</span>
        {subUrl && (
          <>
            <Link href={`/${locale}/services`}>{subUrl}</Link>
            <span>/</span>
          </>
        )}
        <p>{name}</p>
      </div>
      <h3 className='mb-3 text-center text-2xl text-orange  sm:text-5xl font-bold'>{name}</h3>
      {description && (
        <p className='px-5 text-center text-lg font-semibold sm:w-5/12 sm:px-0'>
          {description}
        </p>
      )}
    </div>
  )
}
